import { get, post, download } from '@/utils/request';
//系统配置
export const getParamConfigByCode = data => get('/api/yn-extra/app/paramConfig/getParamConfigByCode', data);
export const getloginParam = data => get('/api/admin-system/sysParamConfig/loginParam', data);
//登录
export const adminUserloginToken = data => post('/api/admin-user/login/token', data);
//验证码
export const adminUserLoginCaptcha = data => get('/api/admin-user/login/captcha', data);
//退出登录
export const adminUserLoginLogout = data => get('/api/admin-user/login/logout', data);
//个人资料-获取用户信息
export const adminUserGetUserInfo = data => get('/api/admin-user/adminUser/getUserInfo', data);
//个人资料-编辑用户信息
export const adminUserUpdateUserInfo = data => post('/api/admin-user/adminUser/updateUserInfo', data);
//个人资料-修改密码
export const adminUserEditPassword = data => post('/api/admin-user/adminUser/editPassword ', data);
//平台下拉列表
export const adminUserPlatformSelect = data => get('/api/admin-user/adminUser/platform/select ', data);

//当前用户菜单树
export const adminUserMenuTree = data => get('/api/admin-user/adminUser/menu/tree ', data);

//首页
//九宫格图表
export const adminIndexGetDateTableData = data => get('/api/admin-index/getDateTableData', data);
//首页游戏排行
export const adminIndexGetGameRankList = data => get('/api/admin-index/getGameRankList', data);
//首页图表数
export const adminIndexGetGameDiagramList = data => get('/api/admin-index/getGameDiagramList', data);
//公告信息列表
export const adminIndexGetNoticePage = data => get('/api/admin-index/getNoticePage', data);
//公告信息最新
export const adminIndexGetNoticeNow = data => get('/api/admin-index/getNoticeNow', data);

//游戏管理
//游戏分类-添加游戏分类
export const adminGameCategoryAdd = data => post('/api/admin-game/category/add', data);
//游戏分类-修改分类
export const adminGameCategoryModify = data => post('/api/admin-game/category/modify', data);
//游戏分类-删除游戏分类
export const adminGameCategoryRemove = data => post('/api/admin-game/category/remove', data);
//游戏分类-游戏分类列表
export const adminGameCategoryList = data => get('/api/admin-game/category/list', data);
//游戏分类-下拉列表
export const adminGameCategorySelect = data => get('/api/admin-game/category/select', data);
//游戏分类-修改分类状态
export const adminGameCategoryModifyStatus = data => post('/api/admin-game/category/modify-status', data);
//游戏分类-游戏分类树
export const adminGameCategoryTree = data => get('/api/admin-game/category/tree', data);

//游戏管理-编辑游戏
export const adminGameModify = data => post('/api/admin-game/modify', data);
//游戏管理-新增游戏
export const adminGameAdd = data => post('/api/admin-game/add', data);
//游戏管理-热门修改
export const adminGameisHot = data => post('/api/admin-game/isHot', data);
//游戏管理-新品修改
export const adminGameisNew = data => post('/api/admin-game/isNew', data);
//游戏管理-游戏列表
export const adminGameList = data => get('/api/admin-game/list', data);
//游戏管理-下拉列表
export const adminGameSelect = data => get('/api/admin-game/select', data);
//游戏管理-启用/禁用
export const adminGameModifyStatus = data => post('/api/admin-game/modify-status', data);
//游戏管理-获取奖池配置
export const adminGamePrizepoolConfig = data => get('/api/admin-game/prizePool/config', data);
//游戏管理-修改奖池配置
export const adminGamePrizepoolConfigModify = data => post('/api/admin-game/prizePool/config/modify', data);
//游戏管理-获取水果机管理配置
export const adminGameFruitGetConfig = data => get('/api/admin-game/fruit/getConfig', data);
//游戏管理-设置水果机管理配置
export const adminGameFruitSetConfig = data => post('/api/admin-game/fruit/updateFruitConfig', data);
//游戏管理-获取水果机系统控盘配置
export const adminGameFruitGetSysConfig = data => get('/api/admin-game/fruit/getSysConfig', data);
//游戏管理-设置水果机系统控盘配置
export const adminGameUpdateFruitSysConfig = data => post('/api/admin-game/fruit/updateFruitSysConfig', data);
//游戏管理-获取f35系统控盘配置
export const adminGameFTFGetSysConfig = data => get('/api/admin-game/game/config/getFTFConfig', data);
//游戏管理-更新f35系统控盘配置
export const adminGameUpdateFTFSysConfig = data => post('/api/admin-game/game/config/editFTFConfig', data);
//游戏管理-新增f35系统控盘配置
export const adminGameAddFTFSysConfig = data => post('/api/admin-game/game/config/addFTFConfig', data);
//游戏管理-游戏控盘配置详情
export const adminGameprofitConfDetail = data => get('/api/admin-game/profitConf/detail', data);
//游戏管理-游戏控盘配置修改
export const adminGameprofitConfModify = data => post('/api/admin-game/profitConf/modify', data);
//游戏管理-长龙提醒详情
export const adminGameprofitConfDragon = data => get('/api/admin-game/profitConf/dragon', data);
export const adminGameprofitConfConf = data => post('/api/admin-game/profitConf/conf', data);
export const adminGameIsLongDragon = data => post('/api/admin-game/isLongDragon', data);

//额度&赔率-列表
export const adminGamePlayPage = data => get('/api/admin-game/play/page', data);
//额度&赔率-编辑
export const adminGamePlayModify = data => post('/api/admin-game/play/modify', data);

//捕鱼-编辑配置
export const adminGameFishConfigModify = data => post('/api/admin-game/fish/config/modify', data);
//捕鱼-配置列表
export const adminGameFishConfigPage = data => get('/api/admin-game/fish/config/page', data);

//电子游戏机器人-投注记录
export const adminGameBotBetRecord = data => get('/api/admin-game/bot/betRecord', data);
//电子游戏机器人-机器人数据统计
export const adminGameBotStatistics = data => get('/api/admin-game/bot/statistics', data);
//电子游戏机器人-机器人数据统计-根据游戏
export const adminGameBotStatisticsByGame = data => get('/api/admin-game/bot/statisticsByGame', data);

//游戏黑名单-添加黑名单
export const adminGameBlacklistAdd = data => post('/api/admin-game/blacklist/add', data);
//游戏黑名单-删除黑名单
export const adminGameBlacklistRemove = data => post('/api/admin-game/blacklist/remove', data);
//游戏黑名单-黑名单分页
export const adminGameBlacklistPage = data => get('/api/admin-game/blacklist/page', data);
//游戏黑名单-快捷用语-列表
export const adminSystemQuickLanguageList = data => get('/api/admin-system/quick-language/list', data);
//游戏黑名单-快捷用语-保存
export const adminSystemQuickLanguageSave = data => post('/api/admin-system/quick-language/save', data);

//Jack Pot
export const adminGameJackPotPage = data => get('/api/admin-game/jackPot/page', data);
export const adminGameJackPotBombPage = data => get('/api/admin-game/jackPot/bombPage', data);
export const adminGameJackPotPrizePage = data => get('/api/admin-game/jackPot/prizePage', data);
export const adminGameJackPotPrizePoolPage = data => get('/api/admin-game/jackPot/prizePoolPage', data);

//订单
//订单列表-所属平台
export const adminGameManagePlatform = data => get('/api/admin-user/adminUser/managePlatform', data);
//订单列表-撤单
export const adminGameOrderCancelOrder = data => post('/api/admin-game/order/cancelOrder', data);
//订单列表-归档订单详情
export const adminGameOrderDetail = data => get('/api/admin-game/order/detail', data);
//订单列表-实时订单详情
export const adminGameMongodbDetail = data => get('/api/admin-game/order/mongodb/detail', data);
//订单列表-实时订单列表
export const adminGamerMongodbOrdePage = data => post('/api/admin-game/order/mongodb/page', data);
//订单列表-实时统计
export const adminGameMongodbOrderSum = data => post('/api/admin-game/order/mongodb/orderSum', data);
//订单列表-归档订单列表
export const adminGameOrderPage = data => post('/api/admin-game/order/page', data);
//订单列表-归档统计
export const adminGameOrderSum = data => post('/api/admin-game/order/orderSum', data);
//用户订单列表
export const adminGameUserOrderPage = data => post('/api/admin-game/order/userOrderPage', data);
//下级用户订单列表
export const adminGameUserSubOrderPage = data => post('/api/admin-game/order/userSubOrderPage', data);
// 订单列表-账变列表
export const userGetByPage = data => get('/api/admin-user/user/getByPage', data);
// 订单列表-账变统计
export const userGetByStats = data => get('/api/admin-user/user/getByStats', data);
//订单列表-撤单
export const cancelOrder = data => get('/api/admin-game/order/cancelOrder', data);
//订单列表-数据同步
export const orderSync = data => post('/api/admin-game/order/sync', data);
//订单列表-注单详情
export const orderDescribe = data => get('/api/admin-game/order/describe', data);
//订单列表-全部事件
export const eventSelect = data => get('/api/admin-game/eventSelect', data);
//订单列表-删除订单
export const orderDelete = data => get('/api/admin-game/order/delete', data);

//开奖管理
//开奖记录-列表
export const openPrizeRecordList = data => get('/api/admin-game/openPrizeRecord/list', data);
//开奖记录-结算
export const openPrizeRecordSettle = data => post('/api/admin-game/openPrizeRecord/settle', data);
//开奖记录-新增
export const openPrizeRecordSave = data => post('/api/admin-game/openPrizeRecord/save', data);
//运营管理
//游戏预开奖-新增
export const openPrizeAdd = data => post('/api/admin-game/openPrize/add', data);
//游戏预开奖-删除
export const openPrizeDel = data => post('/api/admin-game/openPrize/del', data);
//游戏预开奖-详情
export const openPrizeDetail = data => get('/api/admin-game/openPrize/detail', data);
//游戏预开奖-编辑
export const openPrizeModify = data => post('/api/admin-game/openPrize/modify', data);
//游戏预开奖-列表
export const openPrizePage = data => get('/api/admin-game/openPrize/page', data);
//游戏预开奖-判断期号是否过期
export const openPrizevalidateIssue = data => get('/api/admin-game/openPrize/validateIssue', data);
//游戏胜率配置-列表
export const winConfigPage = data => get('/api/admin-game/winConfig/page', data);
//游戏胜率配置-编辑
export const winConfigModify = data => post('/api/admin-game/winConfig/modify', data);
//游戏胜率配置-修改状态
export const winConfigChangeStatus = data => post('/api/admin-game/winConfig/changeStatus', data);
//游戏胜率配置-根据游戏获取用户分页
export const winConfigUserPage = data => get('/api/admin-game/winConfig/userPage', data);

//实时滚单列表-获取期号
export const actualTimeGetIssue = data => get('/api/admin-game/actualTime/getIssue', data);
//实时滚单列表-汇总数据
export const actualTimeSumAmount = data => get('/api/admin-game/actualTime/sumAmount', data);
//实时滚单列表-实时下注记录
export const actualTimeUserAmountLogPage = data => get('/api/admin-game/actualTime/userAmountLogPage', data);
//实时滚单列表-获取玩法列表
export const playList = data => get('/api/admin-game/play/list', data);
//实时滚单列表-获取预设开奖
export const openPrizeDetailByIssue = data => post('/api/admin-game/openPrize/detailByIssue', data);
//实时滚单列表-获取时间配置
export const actualTimeGetConfig = data => get('/api/admin-game/actualTime/getConfig', data);
//奖池记录-大奖统计列表
export const jackPotPage = data => get('/api/admin-game/jackPot/page', data);
//奖池记录-历史列表
export const jackPotPrizeHistoryPage = data => get('/api/admin-game/jackPot/prizeHistoryPage', data);
//奖池记录-历史列表统计
export const jackPotPrizeHistoryStat = data => get('/api/admin-game/jackPot/prizeHistoryStat', data);
//奖池记录-奖池金额记录
export const jackPotPrizePoolPagel = data => get('/api/admin-game/jackPot/prizePoolPage', data);
//用户控制-列表
export const userWinConfigPage = data => get('/api/admin-game/userWinConfig/page', data);
//用户控制-新增
export const userWinConfigAdd = data => post('/api/admin-game/userWinConfig/add', data);
//用户控制-删除
export const userWinConfigDel = data => post('/api/admin-game/userWinConfig/del', data);
//用户控制-编辑
export const userWinConfigModify = data => post('/api/admin-game/userWinConfig/modify', data);
//用户控制-修改状态
export const userWinConfigChangeStatus = data => post('/api/admin-game/userWinConfig/changeStatus', data);


//系统管理
//权限管理-用户列表（分页列表）
export const adminUserPage = data => post('/api/admin-user/adminUser/page', data);
//权限管理-用户列表（新增/编辑）
export const adminUserSave = data => post('/api/admin-user/adminUser/save', data);
//权限管理-用户列表（删除）
export const adminUserDel = data => get('/api/admin-user/adminUser/del', data);
//权限管理-用户列表（重置密码）
export const adminUserReset = data => post('/api/admin-user/adminUser/reset', data);
//权限管理-用户列表（获取操作人员）
export const getAdminUserList = data => get('/api/admin-system/operatorLog/getAdminUserList', data);
//权限管理-用户列表（获取用户信息）
export const getUserInfoById = data => get('/api/admin-user/adminUser/getUserInfoById', data);
//权限管理-用户列表（重置密钥）
export const resetGooglePw = data => get('/api/admin-user/adminUser/resetGooglePw', data);
//权限管理-用户列表（解锁）
export const adminUserUnlock = data => get('/api/admin-user/adminUser/unlock', data);
//权限管理-用户列表（验证状态）
export const adminUserChangeVerifyFlag = data => get('/api/admin-user/adminUser/changeVerifyFlag', data);
//平台管理-平台用户管理（分页列表）
export const platformUserPage = data => get('/api/admin-system/platform/user/page', data);

//权限管理-角色管理（分页列表）
export const roleList = data => get('/api/admin-permissions/role/page', data);
//权限管理-角色管理（新增）
export const roleAdd = data => post('/api/admin-permissions/role/add', data);
//权限管理-角色管理（编辑）
export const roleModify = data => post('/api/admin-permissions/role/modify', data);
//权限管理-角色管理（删除）
export const roleRemove = data => post('/api/admin-permissions/role/remove', data);
//权限管理-角色管理（授权）
export const roleAuthorize = data => post('/api/admin-permissions/role/authorize', data);
//权限管理-角色管理（角色资源树）
export const roleResourceTree = data => get('/api/admin-permissions/role/roleResourceTree', data);

//权限管理-平台管理（分页列表）
export const platformList = data => get('/api/admin-system/platform/page', data);
//权限管理-平台管理（新增）
export const platformAdd = data => post('/api/admin-system/platform/add', data);
//权限管理-平台管理（编辑）
export const platformModify = data => post('/api/admin-system/platform/modify', data);
//权限管理-平台管理（删除）
export const platformRemove = data => post('/api/admin-system/platform/remove', data);
//权限管理-平台管理（详情）
export const platformInfo = data => get('/api/admin-system/platform/info', data);
//权限管理-平台管理（ip白名单分页）
export const platformIpPage = data => get('/api/admin-system/platform/ip/page', data);
//权限管理-平台管理（新增ip白名单）
export const platformIpAdd = data => post('/api/admin-system/platform/ip/add', data);
//权限管理-平台管理（编辑ip白名单）
export const platformIpModify = data => post('/api/admin-system/platform/ip/modify', data);
//权限管理-平台管理（删除ip白名单）
export const platformIpRemove = data => post('/api/admin-system/platform/ip/remove', data);
//权限管理-平台管理（登录账号）
export const savePlatformUser = data => post('/api/admin-user/adminUser/savePlatformUser', data);
//权限管理-平台管理（平台游戏树）
export const gameTree = data => get('/api/admin-system/platform/game/tree', data);
//权限管理-平台管理（游戏配置）
export const gameModify = data => post('/api/admin-system/platform/game/modify', data);
//权限管理-平台管理（授权菜单）
export const platformAuthorize = data => post('/api/admin-system/platform/authorize', data);
//权限管理-是否为系统平台
export const platformIsSystem = data => get('/api/admin-system/platform/is-system', data);
//权限管理-平台管理（平台下拉列表）
export const platformSelect = data => get('/api/admin-system/platform/select', data);
//权限管理-平台管理（平台拥有资源）
export const platformResource = data => get('/api/admin-system/platform/resource', data);
//权限管理-平台管理（获取平台管理角色ID）
export const platformManageRole = data => get('/api/admin-system/platform/manage/role', data);
//权限管理-平台管理（获取平台ip白名单校验状态）
export const ipGetFlag = data => get('/api/admin-system/platform/ip/getFlag', data);
//权限管理-平台管理（平台ip白名单校验提交）
export const ipSaveFlag = data => post('/api/admin-system/platform/ip/saveFlag', data);
//权限管理-平台管理（当前登录用户-管理其他平台列表(去掉系统默认平台)）
export const manageOtherPlatform = data => get('/api/admin-user/adminUser/manageOtherPlatform', data);
//权限管理-平台管理（平台代码校验）
export const validPlatformCode = data => get('/api/admin-system/platform/validPlatformCode', data);

//ip白名单设置（列表）
export const ipWhitelistPage = data => get('/api/admin-system/ipWhitelist/list', data);
//ip白名单设置（新增/编辑）
export const ipWhitelistSave = data => post('/api/admin-system/ipWhitelist/save', data);
//ip白名单设置（删除）
export const ipWhitelistDel = data => get('/api/admin-system/ipWhitelist/del', data);
//ip白名单设置（启用禁用）
export const ipWhitelistStatus = data => get('/api/admin-system/ipWhitelist/status', data);

//第三方同步信息（实时数据列表）
export const adminGameRecordPage = data => get('/api/admin-game/record/page', data);
//第三方同步信息（实时数据详情）
export const adminGameRecordDetail = data => get('/api/admin-game/record/detail', data);
//第三方同步信息（归档数据列表）
export const adminGameRecordEsPage = data => get('/api/admin-game/record/es/page', data);
//第三方同步信息（归档数据详情）
export const adminGameRecordEsDetail = data => get('/api/admin-game/record/es/detail', data);
//第三方同步信息（同步）
export const adminGameRecordSync = data => get('/api/admin-game/record/sync', data);
//第三方同步信息（重试）
export const adminGameRecordRetry = data => get('/api/admin-game/record/retry', data);
//第三方同步信息（账变）
export const adminGamePrizePoolAmountLogs = data => get('/api/admin-game/prizePool/amountLogs', data);
//第三方同步信息（重试数据列表）
export const adminGameRetryOrderPage = data => get('/api/admin-game/retryOrder/page', data);
//第三方同步信息（撤单）
export const adminGameRecordRevoke = data => post('/api/admin-game/record/revoke', data);
//第三方同步信息（归档数据-数据同步）
export const adminGameRecordSyncRecord = data => post('/api/admin-game/record/syncRecord', data);

//第三方核查数据（列表）
export const prizePoolExceptionRequest = data => get('/api/admin-game/prizePool/exceptionRequest', data);
//第三方核查数据（账变列表）
export const prizePoolAmountLogList = data => get('/api/admin-game/prizePool/amountLogList', data);
//第三方核查数据（订单详情）
export const prizePoolOrderDetail = data => get('/api/admin-game/prizePool/orderDetail', data);
//第三方核查数据（审核）
export const prizePoolAudit = data => get('/api/admin-game/prizePool/audit', data);
//第三方核查数据（补偿）
export const prizePoolCompensation = data => post('/api/admin-game/prizePool/compensation', data);
//第三方核查数据（撤单）
export const adminGamePrizePoolRevoke = data => post('/api/admin-game/prizePool/revoke', data);

//第三方对账（列表）
export const billSyncPage = data => get('/api/admin-third/billSync/page', data);
//第三方对账（审核）
export const billSyncAudit = data => post('/api/admin-third/billSync/audit', data);
//第三方对账（刷新第三方数据）
export const billSyncReportTransfer = data => get('/api/admin-third/billSync/reportTransfer', data);
//第三方对账（校验数据状态）
export const billSyncValidData = data => get('/api/admin-third/billSync/validData', data);
export const billSyncStats = data => get('/api/admin-third/billSync/stats', data);
export const billSyncCheck = data => get('/api/admin-third/billSync/check', data);


//菜单管理（分页列表）
export const menuList = data => get('/api/admin-system/menu/list', data);
//菜单管理（新增）
export const menuAdd = data => post('/api/admin-system/menu/add', data);
//菜单管理（编辑）
export const menuModify = data => post('/api/admin-system/menu/modify', data);
//菜单管理（删除）
export const menuRemove = data => post('/api/admin-system/menu/remove', data);
//菜单管理（树型菜单）
export const menuTree = data => get('/api/admin-system/menu/tree', data);
//菜单管理（获取角色拥有的菜单id）
export const roleMenu = data => get('/api/admin-system/menu/role-menu', data);
//菜单管理（菜单详情）
export const menuInfo = data => get('/api/admin-system/menu/info', data);


//日志管理（分页列表）
export const operatorLogPage = data => post('/api/admin-system/operatorLog/page', data);
//日志管理（获取操作类型）
export const getOperatorType = data => get('/api/admin-system/operatorLog/getOperatorType', data);
//日志管理（详情）
export const operatorLogDetail = data => get('/api/admin-system/operatorLog/detail', data);

//系统参数管理（列表）
export const sysParamConfigList = data => get('/api/admin-system/sysParamConfig/list', data);
//系统参数管理（保存）
export const sysParamConfigSave = data => post('/api/admin-system/sysParamConfig/save', data);
//系统参数管理（查询配置map集合）
export const sysParamConfigMap = data => get('/api/admin-system/sysParamConfig/sysParamConfigMap', data);
//系统参数管理（数据留存配置-列表）
export const scheduledList = data => get('/api/admin-system/sysParamConfig/scheduled/list', data);
//系统参数管理（数据留存配置-备注）
export const scheduledRemark = data => post('/api/admin-system/sysParamConfig/scheduled/remark', data);

//游戏更新设置-服务端更新管理（分页列表）
export const serviceUpdatePage = data => get('/api/admin-system/service-update/page', data);
export const serviceUpdateList = data => get('/api/admin-system/service-update/list', data);
//游戏更新设置-服务端更新管理（内测账号分页）
export const serviceUpdate = data => get('/api/admin-system/service-update', data);
//游戏更新设置-服务端更新管理（新增内测账号）
export const serviceUpdateAdd = data => post('/api/admin-system/service-update/add', data);
//游戏更新设置-服务端更新管理（启用禁用游戏）
export const serviceUpdateModifyStatus = data => post('/api/admin-system/service-update/modify/status', data);
//游戏更新设置-服务端更新管理（删除内测账号）
export const serviceUpdateRemove = data => post('/api/admin-system/service-update/remove', data);
//游戏更新设置-服务端更新管理（获取最新在线人数）
export const serviceUpdatePeopleNum = data => get('/api/admin-system/service-update/peopleNum', data);
//游戏更新设置-服务端更新管理（修改内测账户余额）
export const serviceUpdateModifyBalance = data => post('/api/admin-system/service-update/private-user/modify/balance', data);
//游戏更新设置-服务端更新管理（批量编辑）
export const batchUpdateStatus = data => post('/api/admin-system/service-update/batchUpdateStatus', data);

//游戏更新设置-客户端更新管理（分页列表）
export const sysGameHotVersionList = data => get('/api/admin-system/sysGameHotVersion/list', data);
//游戏更新设置-客户端更新管理（修改）
export const sysGameHotVersionUpdate = data => post('/api/admin-system/sysGameHotVersion/update', data);
//游戏更新设置-客户端更新管理（批量修改）
export const sysGameHotVersionBatchUpdate = data => post('/api/admin-system/sysGameHotVersion/batchUpdate', data);
//游戏更新设置-客户端更新管理（批量更新）
export const sysGameHotVersionBatchUpdateByNow = data => post('/api/admin-system/sysGameHotVersion/batchUpdateByNow', data);
//游戏更新设置-客户端更新管理（热更）
export const getDataByParamCode = data => get('/api/admin-system/sysParamConfig/getDataByParamCode', data);
//游戏更新设置-客户端更新管理（上传电子游戏热更新附件）
export const putZipFile = data => post('/api/admin-system/sysGameHotVersion/putZipFile', data);
//游戏更新设置-客户端更新管理（平台更新列表）
export const sysGameHotVersionGameList = data => get('/api/admin-system/sysGameHotVersion/gameList', data);

//系统敏感词管理（分页列表）
export const sensitiveWordPage = data => get('/api/admin-system/sensitiveWord/page', data);
//系统敏感词管理（修改）
export const sensitiveWordEdit = data => post('/api/admin-system/sensitiveWord/edit', data);
//系统敏感词管理（批量删除）
export const sensitiveWordBatchDel = data => post('/api/admin-system/sensitiveWord/batchDel', data);
//系统敏感词管理（批量增加）
export const sensitiveWordBatchAdd = data => get('/api/admin-system/sensitiveWord/batchAdd', data);

//字典管理（分页列表）
export const dictBizParentList = data => get('/api/admin-system/dict-biz/parent-list', data);
//字典管理（编辑）
export const dictBizSubmit = data => post('/api/admin-system/dict-biz/submit', data);
//字典管理（批量删除）
// export const dictBizRemove = data => post('/api/admin-system/dict-biz/remove', data);
export const dictBizRemove = data => post(`/api/admin-system/dict-biz/remove?ids=${data}`);
//字典管理（详情）
export const dictBizDetail = data => get('/api/admin-system/dict-biz/detail', data);
//字典管理（字典菜单）
export const dictBizTree = data => get('/api/admin-system/dict-biz/tree', data);
//字典管理-字典配置（分页列表）
export const dictBizChildList = data => get('/api/admin-system/dict-biz/child-list', data);

// 用户管理
// 用户列表
export const userList = data => get('/api/admin-user/user/list', data);
// 用户详情
export const userGetUserStats = data => get('/api/admin-user/user/getUserStats', data);
// 用户搜索
export const userGetAccountNameByList = data => get('/api/admin-user/user/getAccountNameByList', data);
// 刷新用户余额
export const userRefreshAccount = data => get('/api/admin-user/user/refreshAccount', data);

// 返水列表
export const userGetReturnList = data => get('/api/admin-user/user/getUserReturnList', data);
// 返水统计
export const userGetReturnAll = data => get('/api/admin-user/user/getUserReturnAll', data);
// 账变
export const userGetUserAmountLogPage = data => get('/api/admin-user/user/getUserAmountLogPage', data);
export const userGetAmountTypeList = data => get('/api/admin-user/user/getAmountTypeList', data);
//同步数据
export const userSyncBill = data => post('/api/admin-user/user/syncBill', data);

export const orderDetailByOtherId = data => get('/api/admin-game/order/detailByOtherId', data);
// 账变数据统计
export const getUserAmountLogStats = data => get('/api/admin-user/user/getUserAmountLogStats', data);

export const getUserTransferDescribe = data => get('/api/admin-game/record/describe', data);

// 用户黑名单
export const userBlacklist = data => get('/api/admin-user/user/blacklist', data);
// 编辑用户黑名单
export const userSaveUserBlack = data => post('/api/admin-user/user/saveUserBlack', data);

// 系统头像
// 系统头像分页接口
export const userHeadPicList = data => get('/api/admin-user/userHeadPic/list', data);
// 系统头像添加
export const userHeadPicSave = data => post('/api/admin-user/userHeadPic/save', data);
// 系统头像删除
export const userHeadPicRemove = data => post('/api/admin-user/userHeadPic/remove', data);

//用户层级
// 用户层级列表分页接口
export const userTierList = data => get('/api/admin-user/userTier/list', data);
// 用户层级列表接口
export const userTierSelect = data => get('/api/admin-user/userTier/select', data);
// 用户层级添加接口
export const userTierSave = data => post('/api/admin-user/userTier/save', data);
// 用户层级删除接口
export const userTierRemove = data => get('/api/admin-user/userTier/remove', data);
// 用户层级修改接口
export const userTierUpdate = data => post('/api/admin-user/userTier/update', data);
// 用户层级转移接口
export const userTierTransferUserTier = data => post('/api/admin-user/userTier/transferUserTier', data);

//用户操作日志
// 用户操作日志分页接口
export const userOperatorLogList = data => get('/api/admin-user/userOperatorLog/list', data);
export const userOperatorLogGetIpPage = data => get('/api/admin-user/userOperatorLog/getIpPage', data);

// 在线用户
export const userOnlineUserList = data => get('/api/admin-user/user/onlineUserList', data);
// 踢下线
export const kickOffline = data => post('/api/admin-user/user/kickOffline', data);
// 提出房间
export const kickOutRoom = data => get('/api/admin-user/user/kickOutRoom', data);

// 禁言管理
export const banSpeakPage = data => get('/api/admin-game/banSpeak/page', data);
export const banSpeakAdd = data => post('/api/admin-game/banSpeak/add', data);
export const banSpeakRemove = data => post('/api/admin-game/banSpeak/remove', data);


//资源管理

// 对象存储
// 对象存储分页接口
export const resourceOssList = data => get('/api/admin-resource/oss/list', data);
// 详情
export const resourceOssDetail = data => get('/api/admin-resource/oss/detail', data);
//
export const resourceOssRemove = data => get('/api/admin-resource/oss/remove', data);
export const resourceOssSave = data => post('/api/admin-resource/oss/save', data);
export const resourceOssUpdate = data => post('/api/admin-resource/oss/update', data);

// 图片上传
export const resourceOssPutFile = data => post('/api/admin-resource/oss/put-file', data);


//统计报表
// 后台游戏报表分页
export const getGameReportPage = data => get('/api/admin-report/getGameReportPage', data);
// 后台游戏报表不分页
export const getGameReportPageList = data => get('/api/admin-report/getGameReportList', data);
// 后台平台报表
export const getPlatformReportPage = data => get('/api/admin-report/getPlatformReportPage', data);
// 后台用户资金报表分页
export const getUserMoneyChangePage = data => get('/api/admin-report/getUserMoneyChangePage', data);
// 后台用户报表分页
export const getUserOrderFinancePage = data => get('/api/admin-report/getUserOrderFinancePage', data);
// 注册用户查询列表
export const getUserRegPage = data => get('/api/admin-report/getUserRegPage', data);
// 同步平台报表今日实时数据
export const syncPlatformReport = data => get('/api/admin-report/syncPlatformReport', data);
// 同步资金报表今日实时数据
export const syncUserMoneyChange = data => get('/api/admin-report/syncUserMoneyChange', data);
// 同步用户报表今日实时数据
export const syncUserOrderFinance = data => get('/api/admin-report/syncUserOrderFinance', data);
// 平台结算清单详情
export const platTransferPage = data => get('/api/admin-report/platTransferPage', data);
// 平台结算清单
export const platTransferList = data => get('/api/admin-report/platTransferList', data);
//
export const getGameReportStats = data => get('/api/admin-report/getGameReportStats', data);
//平台报表合计
export const getPlatformReportStats = data => get('/api/admin-report/getPlatformReportStats', data);
//后台用户报表合计统计
export const getUserOrderFinanceStats = data => get('/api/admin-report/getUserOrderFinanceStats', data);
//后台用户资金报表合计统计
export const getUserMoneyChangeStats = data => get('/api/admin-report/getUserMoneyChangeStats', data);
// 游戏用户报表
export const getGameUserReportStats = data => get('/api/admin-report/getGameUserReportStats', data);
export const getGameUserReportPage = data => get('/api/admin-report/getGameUserReportPage', data);

export const getActivityRewardPageTotal = data => get('/api/admin-report/getActivityRewardPageTotal', data);
export const getActivityRewardPage = data => get('/api/admin-report/getActivityRewardPage', data);
export const getActivityRewardStatsPageTotal = data => get('/api/admin-report/getActivityRewardStatsPageTotal', data);
export const getActivityRewardStatsPage = data => get('/api/admin-report/getActivityRewardStatsPage', data);
export const getDayActivityRewardStatsPageTotal = data => get('/api/admin-report/getDayActivityRewardStatsPageTotal', data);
export const getDayActivityRewardStatsPage = data => get('/api/admin-report/getDayActivityRewardStatsPage', data);
export const platTransferExcel = data => download('/api/admin-report/platTransferExcel', data);



//消息通知
//平台公告
export const platformAdPage = data => get('/api/admin-system/platformAd/page', data);
//添加平台公告
export const platformAdSave = data => post('/api/admin-system/platformAd/save', data);
//编辑平台公告
export const platformAdUpdate = data => post('/api/admin-system/platformAd/update', data);
//平台公告-删除
export const platformAdDel = data => get('/api/admin-system/platformAd/del', data);
//平台公告-立即发送
export const platformAdSend = data => post('/api/admin-system/platformAd/send', data);
//平台公告-撤回
export const platformAdWithdraw = data => post('/api/admin-system/platformAd/withdraw', data);
//轮播广告-列表
export const carouselAdList = data => post('/api/admin-system/carouselAd/list', data);
//轮播广告-新增或修改
export const carouselAdSaveAndUpdate = data => post('/api/admin-system/carouselAd/saveAndUpdate', data);
//轮播广告-发送
export const carouselAdSend = data => post('/api/admin-system/carouselAd/send', data);
//轮播广告-撤销
export const carouselAdRecall = data => post('/api/admin-system/carouselAd/recall', data);
//轮播广告-删除
export const carouselAdRemove = data => post('/api/admin-system/carouselAd/remove', data);
// 游戏活动
export const platformActivityPage = data => get('/api/admin-activity/platformConfig/platformActivityPage', data);
export const platformConfigModifyStatus = data => post('/api/admin-activity/platformConfig/modifyStatus', data);
export const platformConfigRemark = data => post('/api/admin-activity/platformConfig/remark', data);
export const platformConfigRestart = data => post('/api/admin-activity/platformConfig/restart', data);
export const platformActivityGetConfigDetail = data => get('/api/admin-activity/platformConfig/getConfigDetail', data);
export const updatePlatformConfig = data => post('/api/admin-activity/platformConfig/config', data);
export const platformConfigActivityList = data => get('/api/admin-activity/platformConfig/activityList', data);
export const platformActivityList = data => get('/api/admin-activity/platformConfig/platformActivityList', data);
export const activityAwardLogSumPage = data => get('/api/admin-activity/platformConfig/activityAwardLogSumPage', data);
export const activityAwardLogSum = data => get('/api/admin-activity/platformConfig/activityAwardLogSum', data);
export const activityAwardLogPage = data => get('/api/admin-activity/platformConfig/activityAwardLogPage', data);
export const getConfigPlatformList = data => get('/api/admin-activity/platformConfig/getConfigPlatformList', data);
export const platformConfigModifyActivity = data => post('/api/admin-activity/platformConfig/modifyActivity', data);
export const platformActivityVersion = data => get('/api/admin-activity/platformConfig/activityVersion', data);
export const addPlatformActivityConfig = data => post('/api/admin-activity/platformConfig/addPlatformActivityConfig', data);

//运维管理
//客户端线路配置
//列表
export const ipConfigList = data => get('/api/admin-system/ipConfig/list', data);
//保存
export const ipConfigSave = data => post('/api/admin-system/ipConfig/save', data);
//提交备注
export const ipConfigRemark = data => get('/api/admin-system/ipConfig/remark', data);
//删除
export const ipConfigDel = data => get('/api/admin-system/ipConfig/del', data);
